export const ListQueryKey = 'activityGqConfigs';
export const DetailQueryKey = 'activityGqConfig';
export const Urls = {
  selectUrl: '/gqConfig/list',
  updateUrl: '/gqConfig/update',
  deleteUrl: '/gqConfig/delete',
  createUrl: '/gqConfig/create',
  detailUrl: '/gqConfig/detail'
};